import Vue from 'vue'
import { Button, Field, Input, Radio, Select, Checkbox, Message, Tooltip } from 'buefy'

export function initialiseBuefy () {
  Vue.use(Button)
  Vue.use(Field)
  Vue.use(Input)
  Vue.use(Radio)
  Vue.use(Select)
  Vue.use(Checkbox)
  Vue.use(Message)
  Vue.use(Tooltip)
}
